import '@/styles/fonts.scss';
import '@/styles/icons/icons.scss';

import '@/styles/base.scss';